<template>
  <svg
    width="400"
    height="91"
    viewBox="0 0 400 91"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.49998 0.799988C3.99998 0.799988 0.299988 4.5 0.299988 9V82.4C0.299988 86.9 3.99998 90.6 8.49998 90.6H81.9C86.4 90.6 90.1 86.9 90.1 82.4V9C90.1 4.5 86.4 0.799988 81.9 0.799988H8.49998Z"
      fill="white"
    />
    <path
      d="M364.8 40.1C364.8 43.6 363.1 45.3 359.6 45.3H354.4V35H359.6C361.3 35 362.6 35.5 363.5 36.3C364.4 37.2 364.8 38.5 364.8 40.1ZM360.3 29.3H350.3C349.5 29.3 348.8 29.6 348.3 30.1C347.8 30.6 347.5 31.3 347.5 32.1V62.3H354.4V51H359.9C363.7 51 366.7 50.1 368.8 48.2C370.9 46.3 371.9 43.6 371.9 40.1C371.9 37 370.9 34.3 368.9 32.3C366.8 30.3 363.9 29.3 360.3 29.3Z"
      fill="white"
    />
    <path
      d="M332.6 48.3H324.7L328.6 36.7L332.6 48.3ZM328.6 29.1C326.2 29.1 324.7 30 324 31.8L312.7 62.2H319.8L322.6 54.1H334.5L337.2 62.1V62.2H344.4L333.1 31.8C332.5 30 331 29.1 328.6 29.1Z"
      fill="white"
    />
    <path
      d="M392.6 40.1C392.6 43.6 390.9 45.3 387.4 45.3H382.2V35H387.4C389.1 35 390.4 35.5 391.3 36.3C392.2 37.2 392.6 38.5 392.6 40.1ZM396.6 32.3C394.6 30.3 391.8 29.2 388.1 29.2H378.1C377.3 29.2 376.6 29.5 376.1 30C375.6 30.5 375.3 31.2 375.3 32V62.2H382.2V51H387.7C391.5 51 394.5 50.1 396.6 48.2C398.7 46.3 399.7 43.6 399.7 40.1C399.6 37 398.6 34.4 396.6 32.3Z"
      fill="white"
    />
    <path
      d="M137.9 29.3H120.1C119.6 29.3 119.2 29.4 118.9 29.7C118.6 30 118.4 30.4 118.4 30.9V62.3H121.2V46.7H136.1V44.1H121.2V31.9H137.9V29.3ZM145 29.3H142.2V62.3H145V29.3ZM149.6 29.3V31.9H160.2V62.3H163V31.9H173.6V29.3H149.6ZM200.9 57.5L181.4 30.2C181.2 29.9 181 29.7 180.9 29.5C180.8 29.4 180.6 29.2 180.3 29.1C180 29 179.7 28.9 179.3 28.9C178.8 28.9 178.5 29 178.2 29.2C177.9 29.4 177.8 29.7 177.8 30.1V62H180.5V33.4L200.3 61.3C200.8 62 201.4 62.3 202.3 62.3C202.7 62.3 203.1 62.2 203.3 62C203.6 61.8 203.7 61.5 203.7 61.2V29.1H201V57.5H200.9ZM230.9 29.3H212.6C212.1 29.3 211.7 29.4 211.4 29.7C211.1 30 210.9 30.4 210.9 30.9V62.3H230.6V59.7H213.7V46.7H229.4V44.1H213.7V31.9H230.9V29.3ZM252.8 60.2C255 58.5 256.1 56.2 256.1 53.3C256.1 52.2 255.9 51.1 255.5 50.2C255.1 49.3 254.6 48.6 254.1 48C253.6 47.4 252.8 46.9 251.8 46.4C250.8 45.9 250 45.5 249.4 45.3C248.8 45.1 247.8 44.8 246.6 44.4C246.3 44.3 246.1 44.2 245.9 44.2C244.7 43.8 243.8 43.5 243.2 43.3C242.7 43.1 241.9 42.8 241.1 42.4C240.2 42 239.6 41.6 239.2 41.2C238.8 40.8 238.5 40.3 238.1 39.6C237.8 38.9 237.6 38.2 237.6 37.4C237.6 35.4 238.3 33.9 239.8 32.8C241.3 31.7 243.2 31.2 245.6 31.2C248.4 31.2 251 32.1 253.5 33.9L255 31.8C252.3 29.7 249.2 28.7 245.7 28.7C242.6 28.7 240 29.5 238 31C236 32.5 234.9 34.7 234.9 37.5C234.9 38.8 235.1 40 235.6 41C236.1 42 236.8 42.8 237.8 43.5C238.8 44.2 239.8 44.7 240.7 45.1C241.6 45.5 242.8 45.9 244.4 46.4C244.6 46.5 245.1 46.6 245.8 46.8C246.5 47 247 47.2 247.2 47.3C247.4 47.4 247.8 47.5 248.4 47.7C249 47.9 249.4 48.1 249.6 48.2C249.8 48.3 250.2 48.5 250.6 48.8C251.1 49 251.4 49.3 251.6 49.4C251.8 49.6 252 49.8 252.3 50.1C252.6 50.4 252.8 50.7 252.9 51C253 51.3 253.1 51.6 253.2 52C253.3 52.4 253.3 52.8 253.3 53.2C253.3 55.2 252.5 56.9 250.9 58.1C249.3 59.3 247.2 60 244.7 60C240.8 60 237.7 58.5 235.5 55.6L233.6 57.3C234.7 58.9 236.3 60.2 238.2 61.1C240.2 62 242.3 62.5 244.6 62.5C247.9 62.7 250.6 61.9 252.8 60.2ZM278.3 60.2C280.5 58.5 281.6 56.2 281.6 53.3C281.6 52.2 281.4 51.1 281 50.2C280.6 49.3 280.1 48.6 279.6 48C279.1 47.4 278.3 46.9 277.3 46.4C276.3 45.9 275.5 45.5 274.9 45.3C274.3 45.1 273.3 44.8 272.1 44.4C271.8 44.3 271.6 44.2 271.4 44.2C270.2 43.8 269.3 43.5 268.7 43.3C268.2 43.1 267.4 42.8 266.6 42.4C265.7 42 265.1 41.6 264.7 41.2C264.3 40.8 264 40.3 263.6 39.6C263.3 38.9 263.1 38.2 263.1 37.4C263.1 35.4 263.8 33.9 265.3 32.8C266.8 31.7 268.7 31.2 271.1 31.2C273.9 31.2 276.5 32.1 279 33.9L280.5 31.8C277.8 29.7 274.7 28.7 271.2 28.7C268.1 28.7 265.5 29.5 263.5 31C261.5 32.5 260.4 34.7 260.4 37.5C260.4 38.8 260.6 40 261.1 41C261.6 42 262.3 42.8 263.3 43.5C264.3 44.2 265.3 44.7 266.2 45.1C267.1 45.5 268.3 45.9 269.9 46.4C270.1 46.5 270.6 46.6 271.3 46.8C272 47 272.5 47.2 272.7 47.3C272.9 47.4 273.3 47.5 273.9 47.7C274.5 47.9 274.9 48.1 275.1 48.2C275.3 48.3 275.7 48.5 276.1 48.8C276.5 49 276.9 49.3 277.1 49.4C277.3 49.6 277.5 49.8 277.8 50.1C278.1 50.4 278.3 50.7 278.4 51C278.5 51.3 278.6 51.6 278.7 52C278.8 52.4 278.8 52.8 278.8 53.2C278.8 55.2 278 56.9 276.4 58.1C274.8 59.3 272.7 60 270.2 60C266.3 60 263.2 58.5 261 55.6L259.1 57.3C260.2 58.9 261.8 60.2 263.7 61.1C265.7 62 267.8 62.5 270.1 62.5C273.3 62.7 276.1 61.9 278.3 60.2Z"
      fill="black"
    />
    <path d="M297.1 23.4H295.5V67.9H297.1V23.4Z" fill="black" />
    <path
      d="M34.9 55.3C34.9 55.3 37.1 54.5 36.6 47.1C36.3 37.5 35.7 29.6 35.7 29.6"
      stroke="#56BEDA"
      stroke-width="2.2"
      stroke-miterlimit="10"
    />
    <path
      d="M33.8 28.5C33.8 28.5 38 30.3 40.6 27.7C40.6 27.7 41.8 28.8 42.6 29.3C43.4 29.9 44.1 30 45.6 28.7L49.2 24.8C51 22.9 51.1 22.1 49.9 20.5C48.7 18.8 46.3 16 46.3 16C45.1 14.3 44.3 14.5 43.1 15C42 15.6 28.5 21.5 28.5 21.5C27.3 22 26.8 22.9 26.5 24.1C26.2 25.3 17.1 58.7 17.1 58.7C16.4 61.3 15.8 63.9999 18.3 64.5999C22.8 65.7999 24.1 73 39.3 75.4C50.3 77.1 56.5 73.9 56.5 73.9C66.3 78.1 73.4 76.7 73.4 76.7"
      stroke="#56BEDA"
      stroke-width="2.2"
      stroke-miterlimit="10"
    />
    <path
      d="M34.5 64.4C36.3 66.3 40.4 70.4 49.5 68.6"
      stroke="#56BEDA"
      stroke-width="2.2"
      stroke-miterlimit="10"
    />
    <path
      d="M66.1 62.9C66.1 62.9 67.6 66.6 73.1 66.6"
      stroke="#56BEDA"
      stroke-width="2.2"
      stroke-miterlimit="10"
    />
    <path
      d="M55.6 56.9C54.5 52.1 50.2 48.5 45 48.5C41.5 48.5 38.4 50.1 36.4 52.7"
      stroke="#56BEDA"
      stroke-width="2.2"
      stroke-miterlimit="10"
    />
    <path
      d="M73.9 50C71.6 47.1 68 45.3 64 45.3C59.3 45.3 55.2 47.9 53 51.7"
      stroke="#56BEDA"
      stroke-width="2.2"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'white',
    },
  },
}
</script>
